require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./toggleswitch"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./toggleswitch"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./toggleswitch")) : factory(root["./utils"], root["./toggleswitch"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__48__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[68],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__48__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(560);


/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _ToggleSwitchGroup = _interopRequireDefault(__webpack_require__(561));

exports["default"] = _ToggleSwitchGroup["default"];
exports.ToggleSwitchGroup = _ToggleSwitchGroup["default"];

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _toggleswitch = _interopRequireDefault(__webpack_require__(48));

var _ToggleSwitchGroup = _interopRequireDefault(__webpack_require__(562));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var toggleswitchGroupClassName = _ToggleSwitchGroup["default"].toggleswitchGroupClassName.replace(/"/g, '');

var BaPropTypes = _utils.propsUtils.BaPropTypes;

var ToggleSwitchGroup = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(ToggleSwitchGroup, _Component);

  function ToggleSwitchGroup() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = ToggleSwitchGroup.prototype;

  _proto.render = function render() {
    var _cx;

    var _this$props = this.props,
        className = _this$props.className,
        direction = _this$props.direction,
        disabled = _this$props.disabled,
        onChange = _this$props.onChange,
        onClick = _this$props.onClick,
        options = _this$props.options,
        selected = _this$props.selected,
        small = _this$props.small,
        tabIndex = _this$props.tabIndex,
        active = _this$props.active,
        align = _this$props.align,
        hover = _this$props.hover,
        indeterminate = _this$props.indeterminate,
        readOnly = _this$props.readOnly,
        visual = _this$props.visual,
        otherToggleSwitchGroupProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["className", "direction", "disabled", "onChange", "onClick", "options", "selected", "small", "tabIndex", "active", "align", "hover", "indeterminate", "readOnly", "visual"]);
    var classNames = (0, _utils.classnames)(toggleswitchGroupClassName, (_cx = {}, _cx["" + (direction != null ? direction : 'vertical')] = true, _cx));
    var mappedClassName = classNames + " " + (className != null ? className : '');
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
      className: mappedClassName
    }, otherToggleSwitchGroupProps), options.map(function (_ref, index) {
      var label = _ref.label,
          otherToggleSwitchProps = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["label"]);
      var mappedOnChange = onChange ? function () {
        return onChange(label);
      } : undefined;
      var mappedToggled = selected && selected[label] ? true : undefined;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: index,
        className: toggleswitchGroupClassName + "__item"
      }, /*#__PURE__*/_react["default"].createElement(_toggleswitch["default"], (0, _extends2["default"])({
        "aria-labelledby": label,
        "data-tid": "ba-common-toggleswitch-group__toggleswitch-" + index,
        disabled: disabled,
        label: label,
        onChange: mappedOnChange,
        onClick: onClick,
        small: small,
        tabIndex: tabIndex,
        toggled: mappedToggled // include others last, so that props supplied in the options take presidence

      }, otherToggleSwitchProps)));
    }));
  };

  return ToggleSwitchGroup;
}(_react.Component);

exports["default"] = ToggleSwitchGroup;
(0, _defineProperty2["default"])(ToggleSwitchGroup, "propTypes", {
  /** className for ToggleSwitchGroup wrapper */
  className: _propTypes["default"].string,

  /** Direction -  'horizontal' or 'vertical'*/
  direction: _propTypes["default"].oneOf(['horizontal', 'vertical']),

  /** Disabled applied to each ToggleSwitch */
  disabled: _propTypes["default"].bool,

  /** caution: onChange applied to each ToggleSwitch - non-standard signature(string), returning the label of the ToggleSwitch */
  onChange: _propTypes["default"].func.isRequired,

  /** onClick applied to each ToggleSwitch */
  onClick: _propTypes["default"].func,

  /** Contains options for each ToggleSwitch */
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape((0, _extends2["default"])({}, _toggleswitch["default"].propTypes))).isRequired,

  /** small applied to each ToggleSwitch */
  small: _propTypes["default"].bool,

  /** deprecated - no Carbon option */
  active: BaPropTypes.deprecated('deprecated - no Carbon option'),

  /** deprecated - no Carbon option */
  align: BaPropTypes.deprecated('deprecated - no Carbon option'),

  /** deprecated - no Carbon option */
  hover: BaPropTypes.deprecated('deprecated - no Carbon option'),

  /** deprecated - no Carbon option */
  indeterminate: BaPropTypes.deprecated('deprecated - no Carbon option'),

  /** deprecated - no Carbon option(maybe disabled) */
  readOnly: BaPropTypes.deprecated('deprecated - no Carbon option(maybe disabled)'),

  /** deprecated - add toggled property of true or false to the options that are to be seleced or not */
  selected: BaPropTypes.deprecated('deprecated - add toggled property of true or false to the options that are to be seleced or not'),

  /** deprecated - no Carbon option */
  visual: BaPropTypes.deprecated('deprecated - no Carbon option')
});

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(563);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-toggleswitchGroup{display:flex;max-width:100%;position:relative;text-align:left;justify-content:flex-start}.ba-toggleswitchGroup__item .ba-toggleswitch{display:flex;align-items:center}.ba-toggleswitchGroup.is-horizontal{flex-direction:row;align-items:center;justify-content:flex-start}.ba-toggleswitchGroup.is-horizontal .ba-toggleswitchGroup__item{display:inline-block}.ba-toggleswitchGroup.is-horizontal .ba-toggleswitchGroup__item:not(:last-child){margin-right:8px}.ba-toggleswitchGroup.is-vertical{flex-direction:column;justify-content:center;align-items:flex-start}\n", ""]);

// exports
exports.locals = {
	"toggleswitchGroupClassName": "\"ba-toggleswitchGroup\""
};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[559,0]]]);
});